window.splitTiming('html', 'pre-main');
window.addTiming && window.addTiming('appMain');

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from '@nx-fe/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(tap => {
    //  window.endTiming('appMain');
    return tap;
  })
  .catch(err => console.error(err));

//window.splitTiming('appMain', 'loaded');
